import edap from '@homeaway/edap-wrapper';

function updateADL(pageName = 'travelerdash') {
    if (window.analyticsdatalayer.pagename !== pageName) {
        window.analyticsdatalayer.pagename = pageName;
        edap().push({
            name: 'pageview',
        });
    }
}

export default updateADL;
